// Hosted Stripe Payment Links — one per supporter tier.
// ----------------------------------------------------------------------------
// We use these instead of POSTing to /api/checkout/session whenever the app
// is being rendered inside the Android/iOS native shell. The reason: when a
// user has installed our PWA, the Android intent-filter intercepts ANY tap
// on https://holywords144.com/* and reroutes them back into the installed
// app — including the Stripe Checkout redirect that comes back from a
// /api/checkout/session flow. By sending mobile-app users directly to a
// `buy.stripe.com/...` URL (a domain we don't own), the intent-filter
// never fires and the browser stays in Chrome through the full checkout.
// After payment, Stripe redirects to holywords144.com/support?session_id=...
// where our SUPPORT page polls the session and unlocks premium.
//
// Web/desktop users still go through /api/checkout/session as before — no
// change for them. See lib/platform.js → shouldHidePaywall().
export const STRIPE_PAYMENT_LINKS = {
  monthly:  "https://buy.stripe.com/fZubJ207ieJs7LG3ak4F204",
  quarter:  "https://buy.stripe.com/fZu8wQ07ibxg7LGfX64F203",
  annual:   "https://buy.stripe.com/9B69AUg6gatc4zubGQ4F201",
  lifetime: "https://buy.stripe.com/28EdRa6vG8l40je12c4F200",
};

// Per-tier hosted link for one-time gifts ("tip jar"). Not configured yet —
// when/if you create a Stripe Payment Link for tips, paste it here and the
// Support page will surface it in the native shell automatically.
export const STRIPE_TIP_LINK = "";
